import { render, staticRenderFns } from "./CurriculumStepView.vue?vue&type=template&id=795d2df5&scoped=true&lang=pug"
import script from "./CurriculumStepView.vue?vue&type=script&lang=js"
export * from "./CurriculumStepView.vue?vue&type=script&lang=js"
import style0 from "./CurriculumStepView.vue?vue&type=style&index=0&id=795d2df5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795d2df5",
  null
  
)

export default component.exports